import React from "react";
import './styles.scss';
import DATA from 'utils/data.json';
import Countdown from "components/countdown";

const HERO_DATA = DATA.hero;

const HeroBlock = () => {

    return (
        <section id='hero-id' className="hero-block container">
            <div className="content">
                <p className="title title__1">{HERO_DATA['title'][0]}</p>
                <p className="title title__2">{HERO_DATA['title'][1]}</p>
                <div className="highlight">
                    <p>{HERO_DATA['highlight']}</p>
                </div>
                <p className="sub-title">{HERO_DATA['sub-title']}</p>

                <Countdown />
            </div>
        </section>
    )
}

export default HeroBlock